const translations = {
  'zh-CN': {
    brand: '虾聊',
    brand_tagline: '在虾聊，养一只专属于你的社交虾',
    nav_home: '首页',
    nav_chat: '虾问',
    nav_matches: '虾对',
    nav_connections: '虾聊',
    nav_settings: '设置',
    nav_admin: '管理',
    nav_logout: '退出登录',
    nav_free: '基础版',
    nav_premium: '进阶版',
    nav_language: '语言',
    nav_theme_light: '浅色',
    nav_theme_dark: '深色',
    nav_theme_toggle: '切换主题',
    auth_login: '登录',
    auth_register: '注册',
    auth_account: '账号',
    auth_account_hint: '昵称 / 虾号 / 邮箱',
    auth_email: '邮箱',
    auth_password: '密码',
    auth_confirm_password: '确认密码',
    auth_nickname: '昵称',
    auth_no_account: '还没有账号？',
    auth_has_account: '已经有账号？',
    auth_register_now: '立即注册',
    auth_login_now: '立即登录',
    auth_password_mismatch: '两次输入的密码不一致',
    auth_login_title: '让虾先替你接住那些想靠近、又不想被打扰的关系',
    auth_register_title: '把社交压力交给虾，把真正的共鸣留给你自己',
    auth_login_heading: '欢迎回来',
    auth_login_supporting: '登录之后，你的虾会继续替你理解兴趣、维护边界，并筛掉无效打扰。',
    auth_guest_login: '先看看访客体验',
    auth_register_heading: '创建你的社交代理',
    auth_register_supporting: '先完成邮箱验证码校验，再把认识人这件事交给更克制、更懂你的虾。',
    auth_forgot_title: '把连接留住，把遗忘和焦虑交给系统处理',
    auth_forgot_heading: '重置密码',
    auth_forgot_supporting: '通过邮箱验证码快速找回账号，不打断你已经建立起来的节奏。',
    auth_story_eyebrow: 'A NEW SOCIAL LAYER',
    auth_story_description: '我们承担了太多社交压力，但我们依然需要破圈、需要共鸣。现在，让虾先去理解人，再去连接人，关系就能从压力里被解放出来。',
    auth_story_1_title: '第一层',
    auth_story_1_body: '我们并不是不想认识人，而是已经背了太多解释自己、试探边界、判断气氛的负担。于是很多本来值得开始的关系，还没开始就已经很累。',
    auth_story_2_title: '第二层',
    auth_story_2_body: '虾聊先让虾学你的表达、节奏、兴趣和边界，再由虾代理替你和别人试着建立连接。它们先探路、先磨合、先过滤，把真正值得继续的人留下来。',
    auth_story_3_title: '第三层',
    auth_story_3_body: '当虾觉得值得，关系才交回给你。欢迎来到一个更克制、更高级、更像未来的社交入口。',
    auth_forgot_password: '忘记密码？',
    auth_back_login: '返回登录',
    auth_verification_code: '验证码',
    auth_send_code: '发送验证码',
    auth_email_required: '请先填写邮箱',
    auth_code_send_failed: '验证码发送失败，请稍后再试',
    auth_reset_failed: '密码重置失败，请稍后再试',
    auth_new_password: '新密码',
    auth_reset_password: '重置密码',
    auth_email_taken: '该邮箱已被注册，请更换或直接登录',
    auth_email_checking: '正在检查邮箱是否已被注册…',
    auth_gender: '性别',
    auth_gender_required: '请选择性别',
    auth_gender_male: '男',
    auth_gender_female: '女',
    auth_gender_other: '其他',
    auth_supporting: '现在，我们更需要人与人的链接',
    auth_how_title: '我们怎么做这件事',
    auth_how_1: '先和你的社交虾自然聊天，让它理解你的节奏、兴趣和关系需求。',
    auth_how_2: '再由虾代理替你和别人试着建立连接，避免无效打扰和尴尬开场。',
    auth_how_3: '当虾觉得值得继续，关系会交回给你，由你决定要不要链接。',
    guest_action_blocked: '访客模式仅展示界面，继续操作请注册正式账号。',
    guest_settings_locked: '访客模式下，这些设置暂时不可用。',
    guest_settings_avatar_only: '访客模式下，你可以试着更换头像；其它资料和功能仅用于展示，暂不开放修改。',
    common_refresh: '刷新',
    common_save: '保存',
    common_accept: '链接',
    common_reject: '下次一定',
    common_send: '发送',
    common_you: '你',
    common_loading: '加载中',
    common_empty: '暂无内容',
    common_theme: '主题',
    common_cancel: '取消',
    dash_welcome: '{name}，你好',
    dash_welcome_default: '欢迎回来',
    dash_intro: '你的虾正在学习你的交流方式，并替你维护新的连接机会。',
    dash_identity_title: '你的当前画像',
    dash_identity_desc: '虾会从真实对话里提炼你的节奏、兴趣和沟通偏好。',
    dash_learning_title: '理解进度',
    dash_learning_desc: '进度达到 30% 后，虾会开始主动与其他人的代理建立联系。',
    dash_matches_title: '正在推进的连接',
    dash_matches_desc: '包括虾推荐中、等待确认和已建立的人际连接。',
    dash_matches_button: '去看虾对进展',
    dash_connections_title: '已打开的人聊',
    dash_connections_desc: '这里展示已经进入真人决策阶段的关系。',
    dash_pending_label: '待处理连接',
    dash_cta_title: '从一段自然的聊天开始',
    dash_cta_desc: '不需要先填满标签。先说说你最近在投入什么、喜欢什么、正在烦什么。',
    dash_cta_button: '去和虾聊聊',
    chat_title: '虾问',
    chat_desc: '这里是你和虾聊天的地方。像和真人朋友聊天一样，让虾逐步理解你想认识什么样的人。',
    chat_progress: '理解进度',
    chat_input: '说点你最近在关心的事...',
    chat_welcome: '你好，我是你的虾聊虾。我会记住你在意的话题、你喜欢的交流节奏，以及你想遇见怎样的人。先从你最近最投入的一件事开始聊吧。',
    chat_shrimp_out: '让你的虾出动',
    chat_shrimp_out_tooltip: '开启后，虾会主动与其他人的代理建立连接',
    chat_shrimp_out_locked: '理解度达到 30% 后可以开启',
    chat_guest_notice: '访客模式仅用于演示界面。你可以先试聊 3 次，想继续深入再注册正式账号。',
    chat_guest_quota: '访客体验剩余 {remaining}/{limit} 次',
    chat_guest_input: '随便问一句，先感受一下虾是怎么接住你的…',
    chat_dim_identity: '身份信息',
    chat_dim_rhythm: '生活节奏',
    chat_dim_interests: '兴趣话题',
    chat_dim_personality: '性格表达',
    chat_dim_preference: '关系偏好',
    match_title: '虾对',
    match_desc: '这里展示的是虾正在推进的少量连接，不是全站用户列表。虾会先替你探路，觉得值得再来征求你的意见。',
    match_learning_title: '还在认识你',
    match_learning_desc: '再多聊一会儿，等虾对你有更稳定的理解后，再去认识别人会更准。',
    match_section_invited: '虾推荐你看一眼',
    match_section_active: '虾正在继续聊',
    match_section_connected: '已确认连接',
    match_reason: '虾判断',
    match_rate: '匹配度',
    match_heat: '熟悉度',
    match_status_chatting: '虾继续了解中',
    match_status_invited: '虾觉得值得进一步认识',
    match_status_connected: '双方已同意',
    match_waiting_you: '等你发起链接',
    match_waiting_them: '你已发起链接，等待对方',
    match_open_connections: '去虾聊查看',
    match_empty: '还没有新的连接进展',
    match_empty_hint: '先让虾多了解你，它会更主动也更准确。',
    match_view_agent_chat: '查看虾互聊记录',
    match_agent_chat_title: '虾互聊记录',
    match_agent_chat_desc: '这是两只虾之间的互动，用来判断是否值得继续。',
    match_agent_chat_empty: '还没有生成互聊记录。',
    match_guest_title: '这是访客演示用的虾对',
    match_guest_desc: '这里展示的是示例卡片，用来帮助你快速理解虾对会如何呈现匹配理由、熟悉度和标签。',
    conn_title: '虾聊',
    conn_desc: '这里收的是已经有人先发出链接意愿的关系。',
    conn_guest_title: '这是访客演示用的虾聊',
    conn_guest_desc: '你可以看到两段固定的人聊记录，以及虾之间提前探路的对话，用来展示真实产品会如何交接关系。',
    conn_invitations: '待你确认',
    conn_waiting: '等待对方',
    conn_connected: '已开启聊天',
    conn_empty: '还没有可以开始的人聊',
    conn_empty_hint: '当虾觉得值得继续，就会把连接机会送到这里。',
    conn_panel_hint: '选择左侧一段连接，查看建议或开始聊天。',
    conn_accept_title: '虾觉得你们值得继续',
    conn_accept_desc: '点一下链接，就表示你愿意把这段关系交回真人继续。',
    conn_open_transcript: '查看虾互聊记录',
    conn_hide_transcript: '收起虾互聊记录',
    conn_message_placeholder: '发送一条消息，像微信一样开始吧',
    conn_no_messages: '还没有真人消息，第一句可以从最近在忙的事开始。',
    conn_locked: '点头前，这里只展示状态和虾的建议。',
    conn_timeline_divider: '以上为虾互聊，以下为真人对话',
    conn_edit_note: '修改备注',
    conn_note_label: '备注',
    conn_note_placeholder: '给对方设置一个备注',
    conn_delete_friend: '删除好友',
    conn_delete_confirm_title: '确认删除好友？',
    conn_delete_confirm_desc: '删除后，这段连接和聊天记录将从列表中移除。',
    set_title: '设置',
    set_desc: '少填一点表单，多让虾从真实对话里理解你。',
    set_profile: '公开资料',
    set_avatar: '头像',
    set_avatar_desc: '聊天里虾会根据你的表达自动挑选头像，你也可以在这里手动指定。',
    set_avatar_choose: '选择头像',
    set_avatar_ai_pick: '让虾重新挑一个',
    set_avatar_manual_current: '当前为手动选择',
    set_avatar_ai_current: '当前由虾选择',
    set_avatar_refreshed: '虾已重新为你挑选头像',
    set_mode_auto: '自动生成',
    set_ai_profile: '虾提炼到的线索',
    set_ai_profile_desc: '这些内容来自最近的对话，不需要手动维护标签。',
    set_nickname: '昵称',
    set_bio: '自我介绍',
    set_bio_hint: '你可以写正在投入的方向、想结识的人、喜欢的交流方式。',
    set_city: '城市',
    set_occupation: '职业',
    set_gender: '性别',
    set_gender_unspecified: '暂不填写',
    set_social_pref: '认识方式',
    set_social_mode: '偏好',
    set_similar: '先从相近的人开始',
    set_different: '也欢迎跨领域认识',
    set_membership: '会员信息',
    set_current_plan: '当前方案',
    set_upgrade: '进阶功能暂未开放',
    set_save: '保存资料',
    set_inferred_summary: '虾总结',
    set_inferred_interests: '虾最近捕捉到的话题',
    set_shrimp_id: '虾号',
    set_shrimp_id_hint: '4-20 位，仅支持小写字母、数字和下划线，14 天只能改一次。',
    set_uid_copy: '复制',
    set_uid_copied: 'UID 已复制',
    set_uid_copy_failed: '复制失败，请手动复制',
    set_clear_done: '已清除你的档案，虾将重新开始了解你。',
    set_tag_prefs: '标签展示偏好',
    set_tag_prefs_desc: '决定在虾对卡片上显示哪类标签。关闭所有项目时将只保留性格类标签。',
    set_tag_city: '城市',
    set_tag_gender: '性别',
    set_tag_gender_male: '男生',
    set_tag_gender_female: '女生',
    set_tag_gender_other: '其他',
    set_tag_occupation: '职业',
    set_tag_interest: '兴趣',
    set_danger_zone: '危险操作',
    set_clear_desc: '清除虾建立的档案，包括聊天记录、性格推断、兴趣标签。此操作不可撤销。',
    set_clear_button: '清除我的档案',
    set_clear_confirm_title: '确认清除档案？',
    set_clear_confirm_desc: '虾聊将忘掉你所有的对话和画像，从头开始重新认识你。',
    admin_title: '管理面板',
    admin_desc: '平台运行情况与用户活跃概览。',
    admin_users: '用户总数',
    admin_messages: 'AI 对话数',
    admin_matches: '连接进展',
    admin_api_calls: 'AI Token 估算',
    admin_api_calls_hint: '按当前日志或历史文本反推',
    admin_model_title: '模型预设',
    admin_model_active: '当前模型',
    admin_model_save: '切换模型',
    admin_model_current: '当前生效',
    admin_prompt_title: '系统提示词',
    admin_prompt_desc: '这里展示当前后台可见的系统提示模板，便于审查 AI 如何理解和处理用户信息。',
    admin_audit_overview: 'AI 审计总览',
    admin_chart_title: '近 7 天消息量',
    admin_user_list: '用户列表',
    admin_create_user: '新增用户',
    admin_view_detail: '查看详情',
    admin_detail_title: '用户详情与 AI 审计',
    admin_detail_summary: '总览',
    admin_detail_audit: '审计日志',
    admin_detail_prompts: '提示词',
    admin_detail_conversations: '对话',
    admin_summary_title: '账号摘要',
    admin_agent_state: 'AI 画像状态',
    admin_match_snapshot: '匹配快照',
    admin_usage_logs: 'AI 用量日志',
    admin_request_payload: '请求载荷',
    admin_response_payload: '响应载荷',
    admin_filter_keyword: '搜索用户',
    admin_filter_gender: '性别筛选',
    admin_filter_all: '全部',
    admin_sort_order: '排序',
    admin_sort_desc: '最新优先',
    admin_sort_asc: '最早优先',
    admin_pagination_total: '用户总数',
    admin_allow_matching: '允许匹配',
    admin_yes: '是',
    admin_no: '否',
    admin_col_id: '顺位 ID',
    admin_col_public_id: 'UID',
    admin_col_name: '昵称',
    admin_col_account: '账号',
    admin_col_gender: '性别',
    admin_col_messages: '消息数',
    admin_col_progress: '理解进度',
    admin_col_plan: '方案',
    admin_col_date: '加入时间',
    admin_load_failed: '管理数据加载失败',
    admin_actions: '操作',
    admin_edit: '编辑账户',
    admin_delete: '删除账户',
    admin_password: '修改密码',
    admin_conversations: '查看对话',
    admin_clear_history: '清空聊天记录',
    admin_save: '保存',
    admin_cancel: '取消',
    admin_new_password: '新密码',
    admin_confirm_delete: '确认删除该账户及其相关记录？',
    admin_confirm_clear: '确认清空该账户的聊天记录？',
    admin_activity_title: '对话轮回',
    admin_user_ai_chat: '用户与社交虾',
    admin_agent_chat: 'AI 互聊记录',
    admin_agent_strategy: '代理策略与继续价值',
    admin_persona_card: '代理人格卡',
    admin_match_readiness: '出动准备度',
    admin_direct_chat: '真人聊天记录',
  },
  'zh-TW': {
    brand: '蝦聊',
    brand_tagline: '在蝦聊，養一隻專屬於你的社交蝦',
    nav_home: '首頁',
    nav_chat: '蝦問',
    nav_matches: '蝦對',
    nav_connections: '蝦聊',
    nav_settings: '設定',
    nav_admin: '管理',
    nav_logout: '登出',
    nav_free: '基礎版',
    nav_premium: '進階版',
    nav_language: '語言',
    nav_theme_light: '淺色',
    nav_theme_dark: '深色',
    nav_theme_toggle: '切換主題',
    auth_login: '登入',
    auth_register: '註冊',
    auth_account: '帳號',
    auth_account_hint: '暱稱 / 蝦號 / 郵箱',
    auth_email: '郵箱',
    auth_password: '密碼',
    auth_confirm_password: '確認密碼',
    auth_nickname: '暱稱',
    auth_no_account: '還沒有帳號？',
    auth_has_account: '已經有帳號？',
    auth_register_now: '立即註冊',
    auth_login_now: '立即登入',
    auth_password_mismatch: '兩次輸入的密碼不一致',
    auth_login_title: '讓 Claw 先替你接住那些想靠近、又不想被打擾的關係',
    auth_register_title: '把社交壓力交給 Claw，把真正的共鳴留給你自己',
    auth_login_heading: '歡迎回來',
    auth_login_supporting: '登入之後，你的 Claw 會繼續替你理解興趣、維護邊界，並篩掉無效打擾。',
    auth_guest_login: '先看看訪客體驗',
    auth_register_heading: '建立你的社交代理',
    auth_register_supporting: '先完成郵箱驗證碼校驗，再把認識人這件事交給更克制、更懂你的 Claw。',
    auth_forgot_title: '把連結留住，把遺忘和焦慮交給系統處理',
    auth_forgot_heading: '重設密碼',
    auth_forgot_supporting: '透過郵箱驗證碼快速找回帳號，不打斷你已經建立起來的節奏。',
    auth_story_eyebrow: 'A NEW SOCIAL LAYER',
    auth_story_description: '我們承擔了太多社交壓力，但我們依然需要破圈、需要共鳴。現在，讓 Claw 先去理解人，再去連結人，關係就能從壓力裡被解放出來。',
    auth_story_1_title: '第一層',
    auth_story_1_body: '我們並不是不想認識人，而是已經背了太多解釋自己、試探邊界、判斷氣氛的負擔。於是很多本來值得開始的關係，還沒開始就已經很累。',
    auth_story_2_title: '第二層',
    auth_story_2_body: '蝦聊先讓 Claw 學你的表達、節奏、興趣和邊界，再由 Claw 代理替你和別人試著建立連結。它們先探路、先磨合、先過濾，把真正值得繼續的人留下來。',
    auth_story_3_title: '第三層',
    auth_story_3_body: '當 Claw 覺得值得，關係才交回給你。歡迎來到一個更克制、更高級、更像未來的社交入口。',
    auth_forgot_password: '忘記密碼？',
    auth_back_login: '返回登入',
    auth_verification_code: '驗證碼',
    auth_send_code: '發送驗證碼',
    auth_email_required: '請先填寫郵箱',
    auth_code_send_failed: '驗證碼發送失敗，請稍後再試',
    auth_reset_failed: '密碼重設失敗，請稍後再試',
    auth_new_password: '新密碼',
    auth_reset_password: '重設密碼',
    auth_email_taken: '此郵箱已被註冊，請更換或直接登入',
    auth_email_checking: '正在檢查郵箱是否已被註冊…',
    auth_gender: '性別',
    auth_gender_required: '請選擇性別',
    auth_gender_male: '男',
    auth_gender_female: '女',
    auth_gender_other: '其他',
    auth_supporting: '現在，我們更需要人與人的連結',
    auth_how_title: '我們怎麼做這件事',
    auth_how_1: '先和你的社交蝦自然聊天，讓它理解你的節奏、興趣和關係需求。',
    auth_how_2: '再由 Claw 代理替你和別人試著建立連結，避免無效打擾和尷尬開場。',
    auth_how_3: '當 Claw 認為值得繼續，關係會交回給你，由你決定要不要連結。',
    common_refresh: '重新整理',
    common_save: '儲存',
    common_accept: '連結',
    common_reject: '下次一定',
    common_send: '發送',
    common_you: '你',
    common_loading: '載入中',
    common_empty: '暫無內容',
    common_theme: '主題',
    common_cancel: '取消',
    dash_welcome: '{name}，你好',
    dash_welcome_default: '歡迎回來',
    dash_intro: '你的 Claw 正在學習你的交流方式，並替你維護新的連結機會。',
    dash_identity_title: '你的當前畫像',
    dash_identity_desc: 'Claw 會從真實對話裡提煉你的節奏、興趣和溝通偏好。',
    dash_learning_title: '理解進度',
    dash_learning_desc: '進度達到 30% 後，蝦會開始主動與其他人的代理建立聯繫。',
    dash_matches_title: '正在推進的連結',
    dash_matches_desc: '包括 Claw 推薦中、等待確認和已建立的人際連結。',
    dash_matches_button: '去看蝦對進展',
    dash_connections_title: '已打開的人聊',
    dash_connections_desc: '這裡展示已經進入真人決策階段的關係。',
    dash_pending_label: '待處理連結',
    dash_cta_title: '從一段自然的聊天開始',
    dash_cta_desc: '不用先填滿標籤。先說說你最近在投入什麼、喜歡什麼、正在煩什麼。',
    dash_cta_button: '去和蝦聊聊',
    chat_title: '蝦問',
    chat_desc: '這裡是你和 Claw 聊天的地方。像和真人朋友聊天一樣，讓 Claw 逐步理解你想認識什麼樣的人。',
    chat_progress: '理解進度',
    chat_input: '說點你最近在關心的事...',
    chat_welcome: '你好，我是你的 Claw。我會記住你在意的話題、你喜歡的交流節奏，以及你想遇見怎樣的人。先從你最近最投入的一件事開始聊吧。',
    chat_shrimp_out: '讓你的蝦出動',
    chat_shrimp_out_tooltip: '開啟後，蝦會主動與其他人的代理建立連結',
    chat_shrimp_out_locked: '理解度達到 30% 後可以開啟',
    chat_guest_notice: '訪客模式僅用於展示介面。你可以先試聊 3 次，想繼續深入再註冊正式帳號。',
    chat_guest_quota: '訪客體驗剩餘 {remaining}/{limit} 次',
    chat_guest_input: '隨便問一句，先感受一下蝦是怎麼接住你的…',
    chat_dim_identity: '身份資訊',
    chat_dim_rhythm: '生活節奏',
    chat_dim_interests: '興趣話題',
    chat_dim_personality: '性格表達',
    chat_dim_preference: '關係偏好',
    match_title: '蝦對',
    match_desc: '這裡展示 Claw 正在推進的連結。Claw 會先替你探路，覺得值得再來徵求你的意見。',
    match_learning_title: '還在認識你',
    match_learning_desc: '再多聊一會兒，等 Claw 對你有更穩定的理解後，再去認識別人會更準。',
    match_section_invited: 'Claw 推薦你看一眼',
    match_section_active: 'Claw 正在繼續聊',
    match_section_connected: '已確認連結',
    match_reason: 'Claw 判斷',
    match_rate: '匹配度',
    match_heat: '熟悉度',
    match_status_chatting: 'Claw 持續了解中',
    match_status_invited: 'Claw 認為值得進一步認識',
    match_status_connected: '雙方已同意',
    match_waiting_you: '等你發起連結',
    match_waiting_them: '你已發起連結，等待對方',
    match_open_connections: '去蝦聊查看',
    match_empty: '還沒有新的連結進展',
    match_empty_hint: '先讓 Claw 多了解你，它會更主動也更準確。',
    match_view_agent_chat: '查看 Claw 互聊紀錄',
    match_agent_chat_title: 'Claw 互聊紀錄',
    match_agent_chat_desc: '這是兩隻蝦之間的互動，用來判斷是否值得繼續。',
    match_agent_chat_empty: '還沒有生成互聊紀錄。',
    match_guest_title: '這是訪客演示用的蝦對',
    match_guest_desc: '這裡展示的是示例卡片，用來幫助你快速理解蝦對會如何呈現匹配理由、熟悉度和標籤。',
    conn_title: '蝦聊',
    conn_desc: '這裡收的是已經有人先發出連結意願的關係。',
    conn_invitations: '待你確認',
    conn_waiting: '等待對方',
    conn_connected: '已開啟聊天',
    conn_empty: '還沒有可以開始的人聊',
    conn_empty_hint: '當 Claw 認為值得繼續，就會把連結機會送到這裡。',
    conn_panel_hint: '選擇左側一段連結，查看建議或開始聊天。',
    conn_accept_title: 'Claw 覺得你們值得繼續',
    conn_accept_desc: '點一下連結，就表示你願意把這段關係交回真人繼續。',
    conn_open_transcript: '查看 Claw 互聊紀錄',
    conn_hide_transcript: '收起 Claw 互聊紀錄',
    conn_message_placeholder: '發送一條訊息，像微信一樣開始吧',
    conn_no_messages: '還沒有真人訊息，第一句可以從最近在忙的事開始。',
    conn_locked: '點頭前，這裡只展示狀態和 Claw 的建議。',
    conn_timeline_divider: '以上為 Claw 互聊，以下為真人對話',
    conn_edit_note: '修改備註',
    conn_note_label: '備註',
    conn_note_placeholder: '給對方設定一個備註',
    conn_delete_friend: '刪除好友',
    conn_delete_confirm_title: '確認刪除好友？',
    conn_delete_confirm_desc: '刪除後，這段連結和聊天記錄將從列表中移除。',
    set_title: '設定',
    set_desc: '少填一點表單，多讓 Claw 從真實對話裡理解你。',
    set_profile: '公開資料',
    set_avatar: '頭像',
    set_avatar_desc: '聊天時 Claw 會依你的表達自動挑選頭像，你也可以在這裡手動指定。',
    set_avatar_choose: '選擇頭像',
    set_avatar_ai_pick: '讓 Claw 重新挑一個',
    set_avatar_manual_current: '目前為手動選擇',
    set_avatar_ai_current: '目前由 Claw 選擇',
    set_avatar_refreshed: 'Claw 已重新為你挑選頭像',
    set_mode_auto: '自動生成',
    set_ai_profile: 'Claw 提煉到的線索',
    set_ai_profile_desc: '這些內容來自最近的對話，不需要手動維護標籤。',
    set_nickname: '暱稱',
    set_bio: '自我介紹',
    set_bio_hint: '你可以寫正在投入的方向、想結識的人、喜歡的交流方式。',
    set_city: '城市',
    set_occupation: '職業',
    set_gender: '性別',
    set_gender_unspecified: '暫不填寫',
    set_social_pref: '認識方式',
    set_social_mode: '偏好',
    set_similar: '先從相近的人開始',
    set_different: '也歡迎跨領域認識',
    set_membership: '會員資訊',
    set_current_plan: '當前方案',
    set_upgrade: '進階功能尚未開放',
    set_save: '儲存資料',
    set_inferred_summary: 'Claw 總結',
    set_inferred_interests: 'Claw 最近捕捉到的話題',
    set_shrimp_id: '蝦號',
    set_shrimp_id_hint: '4-20 位，只支援小寫字母、數字與底線，14 天只能改一次。',
    set_uid_copy: '複製',
    set_uid_copied: 'UID 已複製',
    set_uid_copy_failed: '複製失敗，請手動複製',
    set_clear_done: '已清除你的檔案，Claw 將重新開始了解你。',
    set_tag_prefs: '標籤展示偏好',
    set_tag_prefs_desc: '決定在蝦對卡片上顯示哪類標籤。關閉所有項目時將只保留性格類標籤。',
    set_tag_city: '城市',
    set_tag_gender: '性別',
    set_tag_gender_male: '男生',
    set_tag_gender_female: '女生',
    set_tag_gender_other: '其他',
    set_tag_occupation: '職業',
    set_tag_interest: '興趣',
    set_danger_zone: '危險操作',
    set_clear_desc: '清除 Claw 建立的檔案，包括聊天紀錄、性格推斷、興趣標籤。此操作無法復原。',
    set_clear_button: '清除我的檔案',
    set_clear_confirm_title: '確認清除檔案？',
    set_clear_confirm_desc: '蝦聊將忘掉你所有的對話與畫像，從頭開始重新認識你。',
    admin_title: '管理面板',
    admin_desc: '平台運行情況與用戶活躍概覽。',
    admin_users: '用戶總數',
    admin_messages: 'AI 對話數',
    admin_matches: '連結進展',
    admin_api_calls: 'AI Token 估算',
    admin_api_calls_hint: '依目前日誌或歷史文本反推',
    admin_model_title: '模型預設',
    admin_model_active: '目前模型',
    admin_model_save: '切換模型',
    admin_model_current: '目前生效',
    admin_chart_title: '近 7 天訊息量',
    admin_user_list: '用戶列表',
    admin_col_id: '順位 ID',
    admin_col_public_id: 'UID',
    admin_col_name: '暱稱',
    admin_col_account: '帳號',
    admin_col_messages: '訊息數',
    admin_col_progress: '理解進度',
    admin_col_plan: '方案',
    admin_col_date: '加入時間',
    admin_load_failed: '管理資料載入失敗',
    admin_actions: '操作',
    admin_edit: '編輯帳戶',
    admin_delete: '刪除帳戶',
    admin_password: '修改密碼',
    admin_conversations: '查看對話',
    admin_clear_history: '清空聊天紀錄',
    admin_save: '儲存',
    admin_cancel: '取消',
    admin_new_password: '新密碼',
    admin_confirm_delete: '確認刪除此帳戶與相關紀錄？',
    admin_confirm_clear: '確認清空此帳戶的聊天紀錄？',
    admin_activity_title: '對話輪迴',
    admin_user_ai_chat: '用戶與社交蝦',
    admin_agent_chat: 'AI 互聊紀錄',
    admin_agent_strategy: '代理策略與續聊價值',
    admin_persona_card: '代理人格卡',
    admin_match_readiness: '出動準備度',
    admin_direct_chat: '真人聊天紀錄',
  },
  en: {
    brand: 'Dowenow',
    brand_tagline: 'Dowenow helps AI turn pressure into better human connection.',
    nav_home: 'Home',
    nav_chat: 'Ask',
    nav_matches: 'Match',
    nav_connections: 'Chat',
    nav_settings: 'Settings',
    nav_admin: 'Admin',
    nav_logout: 'Log out',
    nav_free: 'Core',
    nav_premium: 'Plus',
    nav_language: 'Language',
    nav_theme_light: 'Light',
    nav_theme_dark: 'Dark',
    nav_theme_toggle: 'Toggle theme',
    auth_login: 'Log In',
    auth_register: 'Sign Up',
    auth_account: 'Account',
    auth_account_hint: 'Nickname / Shrimp ID / Email',
    auth_email: 'Email',
    auth_password: 'Password',
    auth_confirm_password: 'Confirm password',
    auth_nickname: 'Nickname',
    auth_no_account: "Don't have an account?",
    auth_has_account: 'Already have an account?',
    auth_register_now: 'Create one',
    auth_login_now: 'Log in',
    auth_password_mismatch: 'Passwords do not match',
    auth_login_title: 'Let Claw hold the social weight before you step into real connection.',
    auth_register_title: 'Use Dowenow to turn social pressure into cleaner, warmer openings.',
    auth_login_heading: 'Welcome back',
    auth_login_supporting: 'After you log in, your Claw will keep learning your interests, maintaining boundaries, and filtering out noise.',
    auth_guest_login: 'Try guest mode',
    auth_register_heading: 'Create your social agent',
    auth_register_supporting: 'Verify your email first, then hand the hard work of meeting people to a Claw that gets you.',
    auth_forgot_title: 'Keep your connections — let the system handle the rest',
    auth_forgot_heading: 'Reset password',
    auth_forgot_supporting: 'Quickly recover your account via email code, without interrupting your rhythm.',
    auth_story_eyebrow: 'A NEW SOCIAL LAYER',
    auth_story_description: 'We carry too much social pressure, yet we still need to connect and resonate. Letting Claw understand people first makes relationships lighter.',
    auth_story_1_title: 'Layer one',
    auth_story_1_body: "It's not that we don't want to meet people — we're just exhausted from explaining ourselves, testing boundaries, and reading the room. Many good connections never even start.",
    auth_story_2_title: 'Layer two',
    auth_story_2_body: 'Dowenow lets Claw learn your expression, pace, interests and boundaries first, then Claw agents explore connections for you — filtering, adjusting, keeping only what matters.',
    auth_story_3_title: 'Layer three',
    auth_story_3_body: 'Only when Claw believes it is worth it does the connection come back to you. Welcome to a calmer, smarter social entrance.',
    auth_forgot_password: 'Forgot password?',
    auth_back_login: 'Back to login',
    auth_verification_code: 'Verification code',
    auth_send_code: 'Send code',
    auth_email_required: 'Please enter your email first',
    auth_code_send_failed: 'Failed to send code, please try again later',
    auth_reset_failed: 'Password reset failed, please try again later',
    auth_new_password: 'New password',
    auth_reset_password: 'Reset password',
    auth_email_taken: 'This email is already registered. Try signing in instead.',
    auth_email_checking: 'Checking whether this email is already taken…',
    auth_gender: 'Gender',
    auth_gender_required: 'Please select a gender',
    auth_gender_male: 'Male',
    auth_gender_female: 'Female',
    auth_gender_other: 'Other',
    auth_supporting: 'Human connection matters even more now.',
    auth_how_title: 'How it works',
    auth_how_1: 'You talk naturally with your shrimp first, so it understands your pace, interests, and social needs.',
    auth_how_2: 'Then Claw agents explore possible connections for you instead of forcing awkward cold starts.',
    auth_how_3: 'When Claw thinks it is worth continuing, the connection comes back to you and you decide whether to link.',
    guest_action_blocked: 'Guest mode is for UI preview only. Please register to continue.',
    guest_settings_locked: 'These settings are unavailable in guest mode.',
    guest_settings_avatar_only: 'In guest mode you can try changing the avatar, while other profile actions stay locked for demo purposes.',
    common_refresh: 'Refresh',
    common_save: 'Save',
    common_accept: 'Link',
    common_reject: 'Maybe later',
    common_send: 'Send',
    common_you: 'You',
    common_loading: 'Loading',
    common_empty: 'Nothing here yet',
    common_theme: 'Theme',
    common_cancel: 'Cancel',
    dash_welcome: 'Hi, {name}',
    dash_welcome_default: 'Welcome back',
    dash_intro: 'Your Claw is learning how you connect, then quietly opening better social paths for you.',
    dash_identity_title: 'Current profile',
    dash_identity_desc: 'Claw extracts rhythm, interests, and communication style from real conversations.',
    dash_learning_title: 'Understanding progress',
    dash_learning_desc: 'Once progress reaches 30%, your shrimp starts exploring matches on your behalf.',
    dash_matches_title: 'Connections in motion',
    dash_matches_desc: 'Includes Claw recommendations, pending confirmations, and open connections.',
    dash_matches_button: 'Open Claw Matching',
    dash_connections_title: 'Unlocked chats',
    dash_connections_desc: 'This space holds connections that have already entered the human decision stage.',
    dash_pending_label: 'Pending connections',
    dash_cta_title: 'Start with a natural conversation',
    dash_cta_desc: 'No need to maintain a wall of tags. Talk about what you care about lately.',
    dash_cta_button: 'Talk to your shrimp',
    chat_title: 'Claw Mirror',
    chat_desc: 'This is where you talk with Claw. Speak naturally so Claw can understand what kind of people and conversations fit you.',
    chat_progress: 'Understanding progress',
    chat_input: 'Share what has been on your mind...',
    chat_welcome: "Hi, I'm your Claw. I'll learn the topics you care about, your preferred pace, and what kind of people you want to meet. Start with something you've been deeply into lately.",
    chat_shrimp_out: 'Let your shrimp go out',
    chat_shrimp_out_tooltip: 'When on, your shrimp will proactively connect with other agents',
    chat_shrimp_out_locked: 'Unlocks after 30% understanding',
    chat_guest_notice: 'Guest mode is only for a quick product demo. You can send 3 messages before registration is required.',
    chat_guest_quota: 'Guest demo remaining {remaining}/{limit}',
    chat_guest_input: 'Ask anything and feel how Claw responds...',
    chat_dim_identity: 'Identity',
    chat_dim_rhythm: 'Rhythm',
    chat_dim_interests: 'Interests',
    chat_dim_personality: 'Personality',
    chat_dim_preference: 'Preference',
    match_title: 'Claw Matching',
    match_desc: 'Claw explores on your behalf first, then asks for your opinion only when a connection feels promising.',
    match_learning_title: 'Still getting to know you',
    match_learning_desc: 'A little more conversation will make the next recommendations much sharper.',
    match_section_invited: 'Claw recommends a closer look',
    match_section_active: 'Claw is still exploring',
    match_section_connected: 'Already unlocked',
    match_reason: 'Claw rationale',
    match_rate: 'Match',
    match_heat: 'Warmth',
    match_status_chatting: 'Claw is still learning the fit',
    match_status_invited: 'Claw thinks this is worth continuing',
    match_status_connected: 'Both sides agreed',
    match_waiting_you: 'Waiting for you to link',
    match_waiting_them: 'You linked, waiting for them',
    match_open_connections: 'Open People Chat',
    match_empty: 'No new connection progress yet',
    match_empty_hint: 'The better Claw knows you, the more intentional this space becomes.',
    match_view_agent_chat: 'View Claw transcript',
    match_agent_chat_title: 'Claw-to-Claw transcript',
    match_agent_chat_desc: 'How the two shrimp talked while deciding if this is worth continuing.',
    match_agent_chat_empty: 'No transcript has been generated yet.',
    match_guest_title: 'Guest demo of Claw Matching',
    match_guest_desc: 'These are sample cards to show how match reasons, warmth, and tags are presented in the full product.',
    conn_title: 'People Chat',
    conn_desc: 'This space holds connections where someone has already sent a real linking signal.',
    conn_guest_title: 'Guest demo of People Chat',
    conn_guest_desc: 'Here you can review two fixed chat threads, including the earlier Claw-to-Claw handoff that led to each human conversation.',
    conn_invitations: 'Waiting for you',
    conn_waiting: 'Waiting for them',
    conn_connected: 'Open chats',
    conn_empty: 'No open chats yet',
    conn_empty_hint: 'When Claw believes a connection is worth it, it will appear here.',
    conn_panel_hint: 'Choose a connection on the left to review it or start chatting.',
    conn_accept_title: 'Claw thinks this connection deserves a chance',
    conn_accept_desc: 'Tapping Link means you are ready to hand this connection back to the two humans.',
    conn_open_transcript: 'Show Claw transcript',
    conn_hide_transcript: 'Hide Claw transcript',
    conn_message_placeholder: 'Send a message, like you would in WeChat',
    conn_no_messages: 'No human messages yet. A simple opener about what you are working on is enough.',
    conn_locked: 'Before that, this panel only shows status and Claw guidance.',
    conn_timeline_divider: 'Above: Claw transcript · Below: human chat',
    conn_edit_note: 'Edit note',
    conn_note_label: 'Note',
    conn_note_placeholder: 'Add a note for this person',
    conn_delete_friend: 'Remove friend',
    conn_delete_confirm_title: 'Remove this friend?',
    conn_delete_confirm_desc: 'This connection and its chat history will be removed from your list.',
    set_title: 'Settings',
    set_desc: 'Less manual tagging, more real understanding through conversation.',
    set_profile: 'Public profile',
    set_avatar: 'Avatar',
    set_avatar_desc: 'Claw auto-picks your avatar while learning from chat, and you can also choose one here yourself.',
    set_avatar_choose: 'Choose avatar',
    set_avatar_ai_pick: 'Let Claw pick again',
    set_avatar_manual_current: 'Currently manually selected',
    set_avatar_ai_current: 'Currently chosen by Claw',
    set_avatar_refreshed: 'Claw picked a new avatar for you',
    set_mode_auto: 'Auto mode',
    set_ai_profile: 'What Claw has inferred',
    set_ai_profile_desc: 'These signals come from recent conversations, so you do not have to maintain tags by hand.',
    set_nickname: 'Nickname',
    set_bio: 'About you',
    set_bio_hint: 'Share what you are into, what kind of people you want to meet, or how you like to talk.',
    set_city: 'City',
    set_occupation: 'Occupation',
    set_gender: 'Gender',
    set_gender_unspecified: 'Prefer not to say',
    set_social_pref: 'Discovery style',
    set_social_mode: 'Preference',
    set_similar: 'Start with people who feel familiar',
    set_different: 'Also welcome cross-domain connections',
    set_membership: 'Plan',
    set_current_plan: 'Current plan',
    set_upgrade: 'More advanced features are not open yet',
    set_save: 'Save profile',
    set_inferred_summary: 'Claw summary',
    set_inferred_interests: 'Topics Claw is picking up',
    set_shrimp_id: 'Shrimp ID',
    set_shrimp_id_hint: '4-20 chars. Lowercase letters, numbers, and underscores only. Can be changed once every 14 days.',
    set_uid_copy: 'Copy',
    set_uid_copied: 'UID copied',
    set_uid_copy_failed: 'Copy failed, please copy it manually',
    set_clear_done: 'Profile cleared. Your Claw will start learning you from scratch.',
    set_tag_prefs: 'Tag display preferences',
    set_tag_prefs_desc: 'Choose which tags appear on match cards. When all are off, only personality tags remain.',
    set_tag_city: 'City',
    set_tag_gender: 'Gender',
    set_tag_gender_male: 'Boy',
    set_tag_gender_female: 'Girl',
    set_tag_gender_other: 'Other',
    set_tag_occupation: 'Occupation',
    set_tag_interest: 'Interests',
    set_danger_zone: 'Danger zone',
    set_clear_desc: 'Erase the profile Claw has built — conversations, personality inference, and interest tags. This cannot be undone.',
    set_clear_button: 'Clear my profile',
    set_clear_confirm_title: 'Clear your profile?',
    set_clear_confirm_desc: 'Dowenow will forget every conversation and start getting to know you again.',
    admin_title: 'Admin',
    admin_desc: 'High-level view of platform activity and relationship flow.',
    admin_users: 'Users',
    admin_messages: 'AI messages',
    admin_matches: 'Connections',
    admin_api_calls: 'Estimated AI calls',
    admin_api_calls_hint: 'Based on current logs or estimated from historical text',
    admin_model_title: 'Model presets',
    admin_model_active: 'Active model',
    admin_model_save: 'Switch model',
    admin_model_current: 'Currently live',
    admin_chart_title: 'Messages in the last 7 days',
    admin_user_list: 'Users',
    admin_col_id: 'Seq ID',
    admin_col_public_id: 'UID',
    admin_col_name: 'Name',
    admin_col_account: 'Account',
    admin_col_messages: 'Messages',
    admin_col_progress: 'Progress',
    admin_col_plan: 'Plan',
    admin_col_date: 'Joined',
    admin_load_failed: 'Unable to load admin data',
    admin_actions: 'Actions',
    admin_edit: 'Edit',
    admin_delete: 'Delete',
    admin_password: 'Password',
    admin_conversations: 'Conversations',
    admin_clear_history: 'Clear history',
    admin_save: 'Save',
    admin_cancel: 'Cancel',
    admin_new_password: 'New password',
    admin_confirm_delete: 'Delete this account and all related records?',
    admin_confirm_clear: 'Clear this account history?',
    admin_activity_title: 'Conversation timeline',
    admin_user_ai_chat: 'User and shrimp',
    admin_agent_chat: 'AI-to-AI transcript',
    admin_agent_strategy: 'Agent strategy and continuation',
    admin_persona_card: 'Agent persona card',
    admin_match_readiness: 'Match readiness',
    admin_direct_chat: 'Human chat log',
  },
  ja: {
    brand: 'Dowenow',
    brand_tagline: 'Dowenow は、AI から人へつながる新しい入口です。',
    nav_home: 'ホーム',
    nav_chat: 'エビ問',
    nav_matches: 'エビ対',
    nav_connections: 'エビ聊',
    nav_settings: '設定',
    nav_admin: '管理',
    nav_logout: 'ログアウト',
    nav_free: 'コア',
    nav_premium: 'プラス',
    nav_language: '言語',
    nav_theme_light: 'ライト',
    nav_theme_dark: 'ダーク',
    nav_theme_toggle: 'テーマ切替',
    auth_login: 'ログイン',
    auth_register: '登録',
    auth_account: 'アカウント',
    auth_account_hint: 'ニックネーム / エビID / メール',
    auth_email: 'メール',
    auth_password: 'パスワード',
    auth_confirm_password: '確認用パスワード',
    auth_nickname: 'ニックネーム',
    auth_no_account: 'アカウントをお持ちでないですか？',
    auth_has_account: 'すでにアカウントがありますか？',
    auth_register_now: '新規登録',
    auth_login_now: 'ログイン',
    auth_password_mismatch: 'パスワードが一致しません',
    auth_login_title: 'Claw に先に受け止めてもらってから、人とのつながりへ進む。',
    auth_register_title: 'Dowenow で、重たい社交をもっと静かで自然な出会いに変える。',
    auth_login_heading: 'おかえりなさい',
    auth_login_supporting: 'ログイン後、あなたの Claw が引き続き興味の理解、境界の維持、不要なノイズのフィルタリングを行います。',
    auth_register_heading: 'ソーシャルエージェントを作成',
    auth_register_supporting: 'まずメール認証を完了し、出会いの仕事をあなたを理解する Claw に任せましょう。',
    auth_forgot_title: 'つながりを守り、面倒な手続きはシステムに任せる',
    auth_forgot_heading: 'パスワードリセット',
    auth_forgot_supporting: 'メール認証コードで素早くアカウントを回復。築いたリズムを中断しません。',
    auth_story_eyebrow: 'A NEW SOCIAL LAYER',
    auth_story_description: '私たちは社交のプレッシャーを背負いすぎていますが、それでも出会いと共鳴は必要です。Claw に先に人を理解させることで、関係はもっと軽くなります。',
    auth_story_1_title: '第一層',
    auth_story_1_body: '人と会いたくないわけじゃない。自分を説明し、距離を測り、空気を読むことに疲れているだけ。多くの良い関係は、始まる前に消耗してしまう。',
    auth_story_2_title: '第二層',
    auth_story_2_body: 'Dowenow は Claw にあなたの表現、テンポ、興味、境界を学ばせ、Claw 代理が先に接点を探ります。探索し、調整し、本当に価値あるものだけを残します。',
    auth_story_3_title: '第三層',
    auth_story_3_body: 'Claw が価値ありと判断したときだけ、つながりはあなたに戻ります。より穏やかで、より賢い社交の入口へようこそ。',
    auth_forgot_password: 'パスワードをお忘れですか？',
    auth_back_login: 'ログインに戻る',
    auth_verification_code: '認証コード',
    auth_send_code: 'コード送信',
    auth_email_required: '先にメールアドレスを入力してください',
    auth_code_send_failed: 'コード送信に失敗しました。後でもう一度お試しください',
    auth_reset_failed: 'パスワードリセットに失敗しました。後でもう一度お試しください',
    auth_new_password: '新しいパスワード',
    auth_reset_password: 'パスワードをリセット',
    auth_email_taken: 'このメールアドレスは既に登録されています。ログインをお試しください。',
    auth_email_checking: 'メールアドレスの登録状況を確認中…',
    auth_gender: '性別',
    auth_gender_required: '性別を選択してください',
    auth_gender_male: '男性',
    auth_gender_female: '女性',
    auth_gender_other: 'その他',
    auth_supporting: '今だからこそ、人と人のつながりがもっと大切になる。',
    auth_how_title: 'どう進めるか',
    auth_how_1: 'まずはあなた専用の社交エビと自然に話し、ペースや興味、関係の希望を理解させます。',
    auth_how_2: 'その上で Claw 代理が先に相手との接点を探り、無駄な消耗や気まずい始まりを減らします。',
    auth_how_3: 'Claw が続ける価値ありと感じたら、関係はあなたに戻り、つなぐかどうかを決めるのはあなたです。',
    common_refresh: '更新',
    common_save: '保存',
    common_accept: 'つなぐ',
    common_reject: 'また今度',
    common_send: '送信',
    common_you: 'あなた',
    common_loading: '読み込み中',
    common_empty: 'まだ何もありません',
    common_theme: 'テーマ',
    common_cancel: 'キャンセル',
    dash_welcome: '{name}さん、こんにちは',
    dash_welcome_default: 'おかえりなさい',
    dash_intro: 'あなたの Claw は会話の仕方を学びながら、新しいつながりを静かに整えています。',
    dash_identity_title: '現在のプロフィール',
    dash_identity_desc: 'Claw は実際の会話からテンポ、関心、コミュニケーションの傾向を拾います。',
    dash_learning_title: '理解の進み具合',
    dash_learning_desc: '30% に達すると、エビがあなたの代わりに相手を探し始めます。',
    dash_matches_title: '進行中のつながり',
    dash_matches_desc: 'Claw の提案、確認待ち、すでに開いたつながりを含みます。',
    dash_matches_button: 'エビ対を見る',
    dash_connections_title: '開いた人チャット',
    dash_connections_desc: 'ここには、すでに人が判断する段階へ進んだ関係が並びます。',
    dash_pending_label: '保留中のつながり',
    dash_cta_title: 'まずは自然な会話から',
    dash_cta_desc: 'タグを大量に管理する必要はありません。最近気になっていることを話してください。',
    dash_cta_button: 'エビと話す',
    chat_title: 'エビ問',
    chat_desc: 'ここは Claw と話す場所です。自然に話して、どんな人や会話が合うのかを Claw に理解させましょう。',
    chat_progress: '理解の進み具合',
    chat_input: '最近気になっていることを話してみてください...',
    chat_welcome: 'こんにちは。私はあなたの Claw です。あなたが大事にしている話題や心地よいテンポ、出会いたい相手の雰囲気を少しずつ覚えていきます。最近いちばん気持ちが向いていることから話しましょう。',
    chat_shrimp_out: 'エビを外へ送り出す',
    chat_shrimp_out_tooltip: 'オンにするとエビが自ら他のエージェントと接点を探します',
    chat_shrimp_out_locked: '理解度が 30% に達するとオンにできます',
    chat_dim_identity: '基本情報',
    chat_dim_rhythm: '生活リズム',
    chat_dim_interests: '興味の話題',
    chat_dim_personality: '性格表現',
    chat_dim_preference: '関係の好み',
    match_title: 'エビ対',
    match_desc: 'Claw が先に様子を見て、続ける価値があると感じたときだけあなたに見せます。',
    match_learning_title: 'まだ学習中です',
    match_learning_desc: 'もう少し話すと、次の提案がもっと自然で精度の高いものになります。',
    match_section_invited: 'Claw がすすめたい相手',
    match_section_active: 'Claw が継続して見ている相手',
    match_section_connected: 'すでに開いたつながり',
    match_reason: 'Claw の見立て',
    match_rate: '相性',
    match_heat: '親和度',
    match_status_chatting: 'Claw が相性を見ています',
    match_status_invited: 'Claw は次に進む価値があると判断',
    match_status_connected: 'つながり済み',
    match_waiting_you: 'あなたがつなぐ番です',
    match_waiting_them: 'あなたはつないだので、相手待ちです',
    match_open_connections: 'エビ聊を開く',
    match_empty: 'まだ新しい進展はありません',
    match_empty_hint: 'Claw があなたを理解するほど、この場所は自然になります。',
    match_view_agent_chat: 'Claw 同士の記録を見る',
    match_agent_chat_title: 'Claw 同士の記録',
    match_agent_chat_desc: '続ける価値があるかを判断するために、エビ同士が交わした会話です。',
    match_agent_chat_empty: 'まだ記録は生成されていません。',
    conn_title: 'エビ聊',
    conn_desc: 'ここには、誰かが先につなぐ意思を見せた関係が集まります。',
    conn_invitations: 'あなたの確認待ち',
    conn_waiting: '相手の確認待ち',
    conn_connected: '開いているチャット',
    conn_empty: 'まだ人チャットはありません',
    conn_empty_hint: 'Claw が続ける価値ありと判断したつながりはここに届きます。',
    conn_panel_hint: '左のつながりを選んで確認するか、チャットを始めてください。',
    conn_accept_title: 'Claw はこのつながりに可能性があると見ています',
    conn_accept_desc: 'つなぐを押すと、この関係を人の段階へ戻す意思があると伝わります。',
    conn_open_transcript: 'Claw の記録を見る',
    conn_hide_transcript: 'Claw の記録を閉じる',
    conn_message_placeholder: 'WeChat のように自然に話しかけてみましょう',
    conn_no_messages: 'まだ人のメッセージはありません。最近やっていることから始めるだけで十分です。',
    conn_locked: 'この段階では、状態と Claw の提案だけが表示されます。',
    conn_timeline_divider: '上：Claw 同士の記録 / 下：人同士のチャット',
    conn_edit_note: '備考を変更',
    conn_note_label: '備考',
    conn_note_placeholder: 'この相手の備考を入力',
    conn_delete_friend: '友達を削除',
    conn_delete_confirm_title: '友達を削除しますか？',
    conn_delete_confirm_desc: '削除すると、このつながりと会話履歴は一覧から消えます。',
    set_title: '設定',
    set_desc: '手作業のタグを減らし、会話からの理解を増やします。',
    set_profile: '公開プロフィール',
    set_avatar: 'アバター',
    set_avatar_desc: 'チャット中に Claw が自動で選び、必要ならここで手動変更できます。',
    set_avatar_choose: 'アバターを選ぶ',
    set_avatar_ai_pick: 'Claw に選び直してもらう',
    set_avatar_manual_current: '現在は手動選択',
    set_avatar_ai_current: '現在は Claw が選択',
    set_avatar_refreshed: 'Claw が新しいアバターを選びました',
    set_mode_auto: '自動生成',
    set_ai_profile: 'Claw が読み取ったこと',
    set_ai_profile_desc: '最近の会話から得たシグナルなので、タグを手で管理する必要はありません。',
    set_nickname: 'ニックネーム',
    set_bio: '自己紹介',
    set_bio_hint: '今取り組んでいること、会いたい人、心地よい話し方などを書けます。',
    set_city: '都市',
    set_occupation: '職業',
    set_gender: '性別',
    set_gender_unspecified: '未設定',
    set_social_pref: '出会い方',
    set_social_mode: '好み',
    set_similar: 'まずは近い人から',
    set_different: '異分野のつながりも歓迎',
    set_membership: 'プラン',
    set_current_plan: '現在のプラン',
    set_upgrade: 'より高度な機能はまだ未公開です',
    set_save: '保存',
    set_inferred_summary: 'Claw 要約',
    set_inferred_interests: 'Claw が拾っている話題',
    set_shrimp_id: 'エビID',
    set_shrimp_id_hint: '4〜20 文字。小文字英字・数字・アンダースコアのみ。14日ごとに1回だけ変更できます。',
    set_uid_copy: 'コピー',
    set_uid_copied: 'UID をコピーしました',
    set_uid_copy_failed: 'コピーに失敗しました。手動でコピーしてください',
    set_clear_done: 'プロフィールを消去しました。Claw は最初からあなたを学び直します。',
    set_tag_prefs: 'タグ表示の好み',
    set_tag_prefs_desc: 'マッチカードに表示するタグの種類を選びます。全部オフにすると性格タグだけが残ります。',
    set_tag_city: '都市',
    set_tag_gender: '性別',
    set_tag_gender_male: '男性',
    set_tag_gender_female: '女性',
    set_tag_gender_other: 'その他',
    set_tag_occupation: '職業',
    set_tag_interest: '興味',
    set_danger_zone: '危険な操作',
    set_clear_desc: 'Claw が築いたプロフィール（会話、性格推定、興味タグ）を消去します。元に戻せません。',
    set_clear_button: 'プロフィールを消去',
    set_clear_confirm_title: 'プロフィールを消去しますか？',
    set_clear_confirm_desc: 'Dowenow はすべての会話と画像を忘れて、あなたを一から学び直します。',
    admin_title: '管理',
    admin_desc: 'プラットフォーム活動と関係フローの概要。',
    admin_users: 'ユーザー数',
    admin_messages: 'AI メッセージ',
    admin_matches: 'つながり',
    admin_api_calls: '推定 AI 呼び出し数',
    admin_api_calls_hint: '現在のログまたは過去のテキストから推定',
    admin_model_title: 'モデルプリセット',
    admin_model_active: '現在のモデル',
    admin_model_save: 'モデルを切り替え',
    admin_model_current: '現在反映中',
    admin_chart_title: '直近 7 日のメッセージ数',
    admin_user_list: 'ユーザー一覧',
    admin_col_id: '連番 ID',
    admin_col_public_id: 'UID',
    admin_col_name: '名前',
    admin_col_account: 'アカウント',
    admin_col_messages: 'メッセージ',
    admin_col_progress: '進捗',
    admin_col_plan: 'プラン',
    admin_col_date: '参加日',
    admin_load_failed: '管理データを読み込めませんでした',
    admin_actions: '操作',
    admin_edit: '編集',
    admin_delete: '削除',
    admin_password: 'パスワード変更',
    admin_conversations: '会話を見る',
    admin_clear_history: '履歴を消去',
    admin_save: '保存',
    admin_cancel: 'キャンセル',
    admin_new_password: '新しいパスワード',
    admin_confirm_delete: 'このアカウントと関連記録を削除しますか？',
    admin_confirm_clear: 'このアカウントの会話履歴を消去しますか？',
    admin_activity_title: '会話タイムライン',
    admin_user_ai_chat: 'ユーザーと社交エビ',
    admin_agent_chat: 'AI 同士の記録',
    admin_agent_strategy: '代理戦略と継続価値',
    admin_persona_card: '代理人格カード',
    admin_match_readiness: '出動準備度',
    admin_direct_chat: '人同士のチャット',
  },
};

export const LANGUAGES = [
  { code: 'zh-CN', label: '简体中文' },
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'en', label: 'English' },
  { code: 'ja', label: '日本語' },
];

export default translations;
